import type { Schemas } from '#shopware'

export const listingAggregationsIncludes: Schemas['Includes'] = {
    price_aggregation: ['min', 'max', 'avg', 'sum'],
    manufacturer_aggregation: ['entities'],
    properties_aggregation: ['entities'],
}
